import QuestionnaireApi from '../api/questionnaire';

const env = process.env;
const questionnaireApi = new QuestionnaireApi(
  env.VUE_APP_API_QUESTIONNAIRE_URL,
  parseInt(env.VUE_APP_API_QUESTIONNAIRE_TIMEOUT)
);

const state = {
  questionnaireId: null,
  questionnaires: [],
};

const getters = {
  getQuestionnaires(state) {
    return Array.isArray(state.questionnaires) ? state.questionnaires : [];
  },

  getPopoverQuestionnaire(state, getters) {
    return getters.getQuestionnaires.find(q => q.popover === true);
  },
};

const mutations = {
  QUESTIONNAIRE_SET_QUESTIONNAIRES: (state, payload) => {
    state.questionnaires = payload;
  },
};

const actions = {
  QUESTIONNAIRE_LOAD_QUESTIONNAIRES: async (context) => {
    const token = context.rootState.token;
    const response = await questionnaireApi.getQuestionnaires(token);

    context.commit('QUESTIONNAIRE_SET_QUESTIONNAIRES', response.result);
  },

  QUESTIONNAIRE_SUBMIT_ANSWERS: async (context, payload) => {
    const token = context.rootState.token;
    const {id, answers} = payload;

    await questionnaireApi.submitAnswers(token, id, {answers});

    await context.dispatch('QUESTIONNAIRE_LOAD_QUESTIONNAIRES', id);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
